module.exports = __webpack_public_path__ + "assets/img/lbruant.a61c1aa4.jpg";